import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { Ckeditor } from '@ckeditor/ckeditor5-vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

// import { createPersistedState } from 'pinia-plugin-persistedstate'
// styles
import '@/assets/styles/css/reset.min.css'
import '@/assets/styles/css/font.css'
import '@/assets/styles/css/global.css'


router.afterEach((to) => {
  document.title = to.meta.title || '디코나이';
});

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// init
app.use(router)
app.use(Ckeditor)
app.use(pinia)
app.mount('#app')
